import React, { useState, useEffect } from "react";
import axios from "axios";
import { useLocation, useNavigate, useOutletContext } from "react-router-dom";
import PaginatedSortableTable from "../components/PaginatedSortableTable";
import AgentTree from "../components/AgentTree";
import $ from "jquery";
import "jstree";
import "jstree/dist/themes/default/style.css";
import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import timezone from "dayjs/plugin/timezone";
import DateTimeRangePicker from "../components/DateTimeRangePicker";
import {
  getInitialDateTimeRange,
  getPresetDateTimeRange,
} from "../utils/dateRange";
dayjs.extend(utc);
dayjs.extend(timezone);
window.$ = window.jQuery = $;

export default function GameLimitList() {
  const API_BASE = process.env.REACT_APP_API_BASE_URL;
  const [users, setUser] = useState(null);
  const [user_list, setUser_list] = useState(null);
  const initialRange = getInitialDateTimeRange();
  const [startDateTime, setStartDateTime] = useState(initialRange.start);
  const [endDateTime, setEndDateTime] = useState(initialRange.end);
  const formatDate = (date) => date.toISOString().split("T")[0];
  const { setIsLoggedIn } = useOutletContext();
  const navigate = useNavigate();
  const [totalLogs, setToTalLogs] = useState(null);
  const [selectUser, setSelectUser] = useState(null);
  const [selectUserData, setSelectUserData] = useState(null);
  const [searchField, setSearchField] = useState("username"); // 기본값: 아이디
  const [searchKeyword, setSearchKeyword] = useState("");
  const [includeAll, setIncludeAll] = useState(false);
  const [VendorLimit, setVendorLimit] = useState([]);
  const [limitList, setLimitList] = useState([]);

  const [selectedAgentInfo, setSelectUserInfo] = useState({
    userId: "",
    prefix: "",
    agentsCount: 0,
    usersCount: 0,
    level: "",
  });

  const formatDateTime = (timestamp) => {
    if (!timestamp) return "-";

    const date = dayjs(timestamp).tz("Asia/Seoul"); // 한국시간 변환

    return {
      date: date.format("YYYY-MM-DD"),
      time: date.format("HH:mm:ss"),
    };
  };
  const filteredLogs = (totalLogs ?? [])
    // 1) 먼저 totalAmount > 0 인 항목만 필터링
    .filter((log) => log.totalAmount > 0)
    // 2) 그 후 검색 필터 적용
    .filter((log) => {
      if (!searchKeyword.trim()) return true; // 검색어 없으면 통과
      const keyword = searchKeyword.toLowerCase();

      if (searchField === "username") {
        return log.userId?.toLowerCase().includes(keyword);
      } else if (searchField === "siteUsername") {
        return log.userId?.slice(5)?.toLowerCase().includes(keyword);
      } else if (searchField === "_id") {
        return log.refId?.toString().includes(keyword);
      }
      return true;
    });
  const sortOptions = [
    { value: "reg_dt:asc", label: "처리시간 - 내림차순" },
    { value: "reg_dt:desc", label: "처리시간 - 오름차순" },
  ];
  const handleAgentInfo = (info) => {
    setSelectUserInfo(info);
  };

  function findUserInTree(logUserId, userData) {
    // 1. 루트 users 에서 찾기
    const foundInRoot = userData.users?.find((u) => u.userId === logUserId);
    if (foundInRoot) return foundInRoot;

    // 2. agents를 재귀적으로 순회
    function searchAgents(agents) {
      for (const agent of agents) {
        // 해당 agent 안에 users 중에서 찾기
        const found = agent.users?.find((u) => u.userId === logUserId);
        if (found) return found;

        // 더 깊은 하위 에이전트가 있으면 재귀
        if (agent.agents?.length > 0) {
          const deepFound = searchAgents(agent.agents);
          if (deepFound) return deepFound;
        }
      }
      return null;
    }

    return searchAgents(userData.agents || []);
  }

  const getGameMaxLimit = (gameId) => {
    if (!limitList || limitList.length === 0) return null;

    const found = limitList.find(
      (v) => v.gameId.toLowerCase() === gameId.toLowerCase(),
    );

    return found ? found.maxi : null;
  };

  const getMaxLimit = (vendor) => {
    if (!VendorLimit || VendorLimit.length === 0) return null;

    const found = VendorLimit.find(
      (v) => v.a_thirdparty.toLowerCase() === vendor.toLowerCase(),
    );

    return found ? found.maxi : null;
  };
  const fetchTreeData = async () => {
    try {
      const token = localStorage.getItem("token");
      const res = await axios.get(`${API_BASE}/api/TreeData`, {
        params: {
          selectUserId: selectUser,
        },
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      setSelectUserData(res.data.up_user_id_list);
    } catch (err) {
      if (axios.isAxiosError(err) && err.response) {
        if (
          err.response.status === 401 ||
          err.response.status === 403 ||
          err.response.status === 500
        ) {
          localStorage.removeItem("token");
          setIsLoggedIn(false); // 로그인 상태 false 처리
          navigate("/login"); // 로그인 화면으로 리다이렉트
          return;
        }
      }
      console.error("조회 실패:", err);
    }
  };

  const fetchTotalTransaction_all = async () => {
    try {
      const token = localStorage.getItem("token");
      const res = await axios.get(`${API_BASE}/api/TrxsAll_all`, {
        params: {
          prefix: users.Prefix,
          createdAt_start: startDateTime.replace("T", " ") + ":00",
          createdAt_end: endDateTime.replace("T", " ") + ":59",
        },
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      setToTalLogs(res.data.logs);
    } catch (err) {
      if (axios.isAxiosError(err) && err.response) {
        if (
          err.response.status === 401 ||
          err.response.status === 403 ||
          err.response.status === 500
        ) {
          localStorage.removeItem("token");
          setIsLoggedIn(false); // 로그인 상태 false 처리
          navigate("/login"); // 로그인 화면으로 리다이렉트
          return;
        }
      }
      console.error("조회 실패:", err);
    }
  };

  const fetchTotalTransaction = async () => {
    try {
      const token = localStorage.getItem("token");
      const res = await axios.get(`${API_BASE}/api/TrxsAll`, {
        params: {
          prefix: selectUser,
          createdAt_start: startDateTime.replace("T", " ") + ":00",
          createdAt_end: endDateTime.replace("T", " ") + ":59",
        },
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      setToTalLogs(res.data.logs);
    } catch (err) {
      if (axios.isAxiosError(err) && err.response) {
        if (
          err.response.status === 401 ||
          err.response.status === 403 ||
          err.response.status === 500
        ) {
          localStorage.removeItem("token");
          setIsLoggedIn(false); // 로그인 상태 false 처리
          navigate("/login"); // 로그인 화면으로 리다이렉트
          return;
        }
      }
      console.error("조회 실패:", err);
    }
  };

  const fetchUserInfo = async () => {
    try {
      const token = localStorage.getItem("token");
      const res = await axios.get(`${API_BASE}/api/Users`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      setUser(res.data);
      setSelectUser(res.data.Prefix);

      setSelectUserInfo({
        userId: res.data.myId,
        prefix: res.data.Prefix,
        agentsCount: res.data.myAgentsCount,
        usersCount: res.data.myUsersCount,
        level: res.data.myLevel === "0" ? "super" : `M${res.data.myLevel}`,
      });
    } catch (err) {
      if (axios.isAxiosError(err) && err.response) {
        if (
          err.response.status === 401 ||
          err.response.status === 403 ||
          err.response.status === 500
        ) {
          localStorage.removeItem("token");
          setIsLoggedIn(false); // 로그인 상태 false 처리
          navigate("/login"); // 로그인 화면으로 리다이렉트
          return;
        }
      }
      console.error("유저 정보 불러오기 실패:", err);
    }
  };

  useEffect(() => {
    if (!users || !users.myId) return;

    const fetchLimitData = async () => {
      try {
        const token = localStorage.getItem("token");

        const res = await axios.get(`${API_BASE}/api/UserGameLimit`, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });

        setLimitList(res.data.list); // ⭐ 핵심 부분
      } catch (err) {
        if (axios.isAxiosError(err) && err.response) {
          if (
            err.response.status === 401 ||
            err.response.status === 403 ||
            err.response.status === 500
          ) {
            localStorage.removeItem("token");
            setIsLoggedIn(false);
            navigate("/login");
            return;
          }
        }
        console.error("유저 게임 제한정보 불러오기 실패:", err);
      }
    };

    fetchLimitData();
  }, [users]);

  useEffect(() => {
    if (!users || !users.myId) return;
    const fetchUserInfo = async () => {
      try {
        const token = localStorage.getItem("token");
        const res = await axios.get(`${API_BASE}/api/MyVendorLimit`, {
          params: {
            userId: users.myId,
          },
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });

        setVendorLimit(res.data.limitList);
      } catch (err) {
        if (axios.isAxiosError(err) && err.response) {
          if (
            err.response.status === 401 ||
            err.response.status === 403 ||
            err.response.status === 500
          ) {
            localStorage.removeItem("token");
            setIsLoggedIn(false); // 로그인 상태 false 처리
            navigate("/login"); // 로그인 화면으로 리다이렉트
            return;
          }
        }
        console.error("유저 정보 불러오기 실패:", err);
      }
    };

    fetchUserInfo();
  }, [users]);

  const move = (user) => {
    navigate("/userInfo", {
      state: {
        user: user,
      },
    });
  };

  useEffect(() => {
    fetchUserInfo();
  }, []);

  useEffect(() => {
    if (selectUser) {
      fetchTotalTransaction();
      fetchTreeData();
    }
  }, [selectUser, startDateTime, endDateTime]);

  const handleDateRange = (type) => {
    const range = getPresetDateTimeRange(type);
    setStartDateTime(range.start);
    setEndDateTime(range.end);
  };

  const renderRow = (log, idx) => {
    if (!totalLogs || totalLogs.length === 0) {
      return (
        <tr>
          <td className="text-center span-cell-emt" colSpan="14">
            <div className="nk-order-ovwg-ck text-red">
              <h5>조회된 정보가 없습니다.</h5>
            </div>
          </td>
        </tr>
      );
    }
    return (
      <tr key={log.idx} data-pos-y={idx}>
        <td
          className="text-center"
          colSpan="1"
          data-columns="idd6970004b274a-col-0"
          data-org-colspan="1"
          data-pos-x="0"
          data-priority="1"
          style={{
            display: "table-cell",
          }}
        >
          <button className="btn btn-primary btn-sm btn-xsm">
            <em className="icon ni ni-link" />
          </button>
        </td>

        <td className="text-center" colSpan="1">
          {selectUserData && selectUserData.length > 0 && (
            <>
              {(() => {
                let baseLevel = 0;
                if (selectedAgentInfo.level === "super") {
                  baseLevel = 0;
                } else if (selectedAgentInfo.level.startsWith("M")) {
                  baseLevel = parseInt(
                    selectedAgentInfo.level.replace("M", ""),
                  );
                }

                const items = selectUserData.flatMap((userId, index) => {
                  const level = baseLevel - (selectUserData.length - index);
                  const levelClass = level === 0 ? "super" : `M${level}`;

                  const badge = (
                    <em
                      key={`badge-${userId}`}
                      className={`badge me-1 ${levelClass}`}
                      style={{ cursor: "pointer" }}
                    >
                      {userId}
                    </em>
                  );

                  // 4개마다 줄바꿈
                  if ((index + 1) % 4 === 0) {
                    return [badge, <br key={`br-${userId}`} />];
                  }
                  return [badge];
                });

                // 현재 노드도 마지막에 출력
                items.push(
                  <em
                    key={`self-${selectedAgentInfo.userId}`}
                    className={`badge me-1 ${selectedAgentInfo.level}`}
                    style={{ cursor: "pointer" }}
                  >
                    {selectedAgentInfo.userId}
                  </em>,
                );

                return items;
              })()}
            </>
          )}

          {/* 상위 노드가 없을 때 현재 노드만 출력 */}
          {selectUserData?.length === 0 && (
            <span key={selectedAgentInfo.userId}>
              <em
                className={`badge me-1 ${selectedAgentInfo.level}`}
                style={{ cursor: "pointer" }}
              >
                {selectedAgentInfo.userId}
              </em>
            </span>
          )}
        </td>

        <td
          className="text-center"
          colSpan="1"
          data-columns="idd6970004b274a-col-2"
          data-org-colspan="1"
          data-pos-x="2"
          data-priority="1"
          style={{
            display: "table-cell",
          }}
        >
          <em
            className={`badge me-1 ${selectedAgentInfo.level}`}
            style={{
              cursor: "pointer",
            }}
          >
            {selectedAgentInfo.userId}
          </em>
        </td>
        <td
          className=""
          colSpan="1"
          data-columns="idd6970004b274a-col-3"
          data-org-colspan="1"
          data-pos-x="3"
          data-priority="1"
          style={{
            display: "table-cell",
          }}
        >
          <div className="user-name">
            <span className="badge rounded-pill badge-dim bg-outline-info me-1">
              지갑
            </span>
            <em className="badge rounded-pill badge-dim bg-outline-info me-1 simm">
              S
            </em>
          </div>
          <div className="user-toggle">
            <a className="dropdown-toggle" data-bs-toggle="dropdown" href="#">
              <div className="user-toggle">
                <div className="user-info">
                  <div className="user-name dropdown-indicator">
                    <span className="badge rounded-pill badge-dim bg-outline-danger me-1">
                      아이디
                    </span>{" "}
                    {log.userId}
                  </div>
                  <div className="user-status">
                    <span className="badge rounded-pill badge-dim bg-outline-primary me-1">
                      사이트아이디
                    </span>
                    {log.userId.slice(5)}
                  </div>
                </div>
              </div>
            </a>
            <div className="dropdown-menu dropdown-menu-start">
              <ul className="link-list-opt">
                <li>
                  <a
                    href="#"
                    onClick={(e) => {
                      e.preventDefault();
                      const targetUser = findUserInTree(log.userId, users); // user = 전체 유저 트리
                      if (targetUser) {
                        move(targetUser);
                      } else {
                        alert("해당 유저를 찾을 수 없습니다.");
                      }
                    }}
                  >
                    <em className="icon ni ni-db-fill" />
                    <span>베팅정보</span>
                  </a>
                </li>
                <li>
                  <a
                    href="#"
                    onClick={(e) => {
                      e.preventDefault();
                      const targetUser = findUserInTree(log.userId, users); // user = 전체 유저 트리
                      if (targetUser) {
                        move(targetUser);
                      } else {
                        alert("해당 유저를 찾을 수 없습니다.");
                      }
                    }}
                  >
                    <em className="icon ni ni-user-list" />
                    <span>회원정보</span>
                  </a>
                </li>
                <li>
                  <a
                    href="#"
                    onClick={(e) => {
                      e.preventDefault();
                      navigator.clipboard
                        .writeText(log.userId)
                        .then(() => {})
                        .catch((err) => {
                          console.error("복사 실패:", err);
                        });
                    }}
                  >
                    <em className="icon far fa-copy" />
                    <span>아이디 복사</span>
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </td>
        <td
          className=""
          colSpan="1"
          data-columns="idd6970004b274a-col-4"
          data-org-colspan="1"
          data-pos-x="4"
          data-priority="1"
          style={{
            display: "table-cell",
          }}
        >
          <ul className="bet-log-tb game-type">
            <li>
              <span className="badge rounded-pill badge-dim bg-outline-primary">
                {`${log.gameType} > ${log.vendor}`}
              </span>
            </li>
            <li>
              <span className="gamename">
                <b>{log.gameId}</b>
              </span>
            </li>
            <li className="code">Code : {log.refId}</li>
          </ul>
        </td>
        <td
          className="text-center fw-bold"
          colSpan="1"
          data-columns="idd6970004b274a-col-5"
          data-org-colspan="1"
          data-pos-x="5"
          data-priority="1"
          style={{
            display: "table-cell",
          }}
        >
          <span className="badge rounded-pill bg-pink">회수</span>
        </td>
        <td
          className="text-center text-center"
          colSpan="1"
          data-columns="idd6970004b274a-col-6"
          data-org-colspan="1"
          data-pos-x="6"
          data-priority="1"
          style={{
            display: "table-cell",
          }}
        >
          KRW
        </td>
        <td
          className="text-end"
          colSpan="1"
          data-columns="idd6970004b274a-col-7"
          data-org-colspan="1"
          data-pos-x="7"
          data-priority="1"
          style={{
            display: "table-cell",
          }}
        >
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
            }}
          >
            <div
              style={{
                display: "table-cell",
                textAlign: "left",
              }}
            />
            <div
              className="text-end"
              style={{
                display: "table-cell",
              }}
            >
              <div>
                <span>{log.totalAmount.toLocaleString()}</span>
              </div>
            </div>
          </div>
        </td>
        <td
          className="text-end"
          colSpan="1"
          data-columns="idd6970004b274a-col-8"
          data-org-colspan="1"
          data-pos-x="8"
          data-priority="1"
          style={{ display: "table-cell" }}
        >
          <ul>
            <li>
              <span className="fw-bold">벤더 : </span>
              <span>
                {getMaxLimit(log.vendor)
                  ? getMaxLimit(log.vendor).toLocaleString()
                  : "0"}
              </span>
            </li>

            <li>
              <hr style={{ margin: "8px 0" }} />
            </li>

            <li>
              <span className="fw-bold">게임 : </span>
              <span>
                {" "}
                {getGameMaxLimit(log.gameId)
                  ? getGameMaxLimit(log.gameId).toLocaleString()
                  : "0"}
              </span>
            </li>
          </ul>
        </td>
        <td
          className="text-end"
          colSpan="1"
          data-columns="idd6970004b274a-col-9"
          data-org-colspan="1"
          data-pos-x="9"
          data-priority="1"
          style={{
            display: "table-cell",
          }}
        >
          <div className="text-azure fw-bold">
            <span className="paid">
              <em className="icon ni ni-minus-round-fill" />
              <span>{(log.totalAmount - log.amount).toLocaleString()}</span>
            </span>
          </div>
        </td>
        <td className="text-center" colSpan="1">
          {(() => {
            const { date, time } = formatDateTime(log.createdAt);
            return (
              <span style={{ fontSize: "95%" }}>
                {date}
                <font className="dateInHour"> ({time} UTC +9)</font>
              </span>
            );
          })()}
        </td>
      </tr>
    );
  };

  return (
    <div className="nk-content user_view_wrap">
      <div className="container-fluid">
        <div className="nk-content-inner">
          <div className="nk-content-body">
            <div className="nk-block nk-block-lg vTrxsAll" id="opt-x">
              <div className="card card-bordered">
                <div className="card-inner-group">
                  <div className="card-inner p-3">
                    <div className="nk-block nk-block-lg">
                      <form className="mb-0">
                        <DateTimeRangePicker
                          startDateTime={startDateTime}
                          endDateTime={endDateTime}
                          onStartChange={setStartDateTime}
                          onEndChange={setEndDateTime}
                          onPresetChange={handleDateRange}
                        >
                          <div className="col-sm-6 col-md-6 col-lg-5 col-xl-4 col-xxl-4">
                            <div className="form-control-wrap">
                              <div
                                className="input-group"
                                style={{
                                  flexWrap: "nowrap",
                                }}
                              >
                                <div className="input-group-prepend">
                                  <button
                                    className="btn btn-outline-light btn-dim dropdown-toggle"
                                    data-bs-toggle="dropdown"
                                  >
                                    <span className="dropdown-menu-text">
                                      {
                                        {
                                          username: "아이디",
                                          siteUsername: "사이트 아이디",
                                          _id: "거래코드",
                                        }[searchField]
                                      }
                                    </span>
                                    <em className="icon mx-n1 ni ni-chevron-down" />
                                  </button>
                                  <div
                                    className="dropdown-menu"
                                    id="dropdown-menu-id"
                                  >
                                    <ul className="link-list-opt no-bdr">
                                      <li>
                                        <a
                                          href="#"
                                          onClick={(e) => {
                                            e.preventDefault();
                                            setSearchField("username");
                                          }}
                                        >
                                          아이디
                                        </a>
                                      </li>
                                      <li>
                                        <a
                                          href="#"
                                          onClick={(e) => {
                                            e.preventDefault();
                                            setSearchField("siteUsername");
                                          }}
                                        >
                                          사이트 아이디
                                        </a>
                                      </li>
                                      <li>
                                        <a
                                          href="#"
                                          onClick={(e) => {
                                            e.preventDefault();
                                            setSearchField("_id");
                                          }}
                                        >
                                          거래코드
                                        </a>
                                      </li>
                                    </ul>
                                  </div>
                                </div>
                                <input
                                  className="form-control"
                                  placeholder="검색어"
                                  type="text"
                                  value={searchKeyword}
                                  onChange={(e) =>
                                    setSearchKeyword(e.target.value)
                                  }
                                />
                                <div className="input-group-append">
                                  <button className="btn btn-outline-primary btn-dim">
                                    <em className="icon ni ni-search me-2" />{" "}
                                    검색
                                  </button>
                                </div>
                              </div>
                            </div>
                          </div>
                        </DateTimeRangePicker>
                      </form>
                    </div>
                  </div>
                  <div className="card-inner p-3 cpaginationMongo">
                    <div className="row">
                      <div className="col-12 col-md-4 col-xxl-4">
                        <div className="dropdown partnerTree">
                          <a
                            className="dropdown-toggle btn btn-outline-light"
                            data-bs-toggle="dropdown"
                            href="#"
                            id="dropdownMenuClickable"
                          >
                            <span className="d-none d-sm-inline btn btn-dim btn-outline-primary disabled">
                              에이전트 선택{" "}
                              <em className="dd-indc icon ni ni-chevron-down" />
                            </span>

                            {/* 선택된 레벨 (super, M1 등) */}
                            <span
                              className={`badge ${selectedAgentInfo.level}`}
                            >
                              {selectedAgentInfo.level}
                            </span>

                            {/* 선택된 에이전트 ID + prefix */}
                            <span>
                              {selectedAgentInfo.userId}{" "}
                              {selectedAgentInfo.userId.length > 0
                                ? "(KRW)"
                                : "Loading..."}
                            </span>

                            {/* 선택된 유저/에이전트 수 */}
                            <div className="memNum">
                              <span
                                className="badge"
                                data-bs-original-title="에이전트수"
                                data-bs-toggle="tooltip"
                              >
                                {selectedAgentInfo.agentsCount}
                              </span>
                              <span
                                className="badge"
                                data-bs-original-title="회원수"
                                data-bs-placement="top"
                                data-bs-toggle="tooltip"
                              >
                                {selectedAgentInfo.usersCount}
                              </span>
                            </div>
                          </a>
                          <div
                            aria-labelledby="dropdownMenuClickable"
                            className="dropdown-menu dropdown-menu-xl p-3 ps-1"
                          >
                            {users && (
                              <AgentTree
                                user={users}
                                setUserList={setUser_list}
                                onAgentClick={setSelectUser}
                                onAgentInfo={handleAgentInfo}
                              />
                            )}
                            <div className="row">
                              <div className="col-6">
                                <div
                                  className="btn btn-danger btn-block btn-sm p-0 m-0 btn-reset"
                                  onClick={(e) => {
                                    e.stopPropagation(); // 🔥 드롭다운 닫힘 방지
                                    const tree =
                                      $("#custom-icon-tree").jstree(true);
                                    if (tree) {
                                      tree.close_all(); // 🔄 초기화 실행
                                    }
                                  }}
                                >
                                  <i className="fas fa-redo" />  초기화
                                </div>
                              </div>
                              <div className="col-6">
                                <div className="btn btn-gray btn-block btn-sm p-0 m-0">
                                  <i className="far fa-times-circle" />  닫기
                                </div>
                              </div>
                            </div>
                          </div>
                          <div className="custom-control custom-control-sm custom-switch d-none">
                            <input
                              className="custom-control-input"
                              id="sw-treeAllSelect1745244818039"
                              type="checkbox"
                            />
                            <label
                              className="custom-control-label text-nowrap"
                              htmlFor="sw-treeAllSelect1745244818039"
                            >
                              <strong>하부포함</strong>
                            </label>
                          </div>
                        </div>
                      </div>
                      {/* <div className="col-12 col-md-4 col-xxl-4">
                        <ul
                          className="pagination justify-content-center justify-content-md-start"
                          style={{
                            float: "right",
                          }}
                        >
                          <li className="page-item">
                            <a className="page-link disabled" href="#">
                              <i className="fas fa-angle-double-left" />
                              <font>처음</font>
                            </a>
                          </li>
                          <li className="page-item">
                            <a className="page-link disabled" href="#">
                              <i className="fa fa-angle-left" />
                              <font>이전</font>
                            </a>
                          </li>
                          <li className="page-item">
                            <input
                              className="form-control text-center"
                              type="number"
                            />
                          </li>
                          <li className="page-item">
                            <a className="page-link" href="#">
                              <font>다음</font>
                              <i className="fa fa-angle-right" />
                            </a>
                          </li>
                        </ul>
                      </div> */}
                      {/* <div className="col-6 col-md-2 col-xxl-2">
                        <select className="form-select">
                          <option value="10">리스트 - 10</option>
                          <option value="20">리스트 - 20</option>
                          <option value="50">리스트 - 50</option>
                          <option value="100">리스트 - 100</option>
                        </select>
                      </div>
                      <div className="col-6 col-md-2 col-xxl-2">
                        <select className="form-select">
                          <option value="-1">처리시간 - 내림차순</option>
                          <option value="1">처리시간 - 오름차순</option>
                        </select>
                      </div> */}
                    </div>
                  </div>
                  <div className="card-inner tableBox p-0">
                    <div className="table-responsive">
                      <div data-pattern="priority-columns">
                        <table
                          cellSpacing="0"
                          className="table table-small-font table-tighten table-bordered table-striped"
                        >
                          <thead>
                            <tr>
                              <th
                                className="text-center col-detail"
                                data-priority="1"
                              >
                                상세
                              </th>
                              <th className="text-center" data-priority="1">
                                트리정보
                              </th>
                              <th className="text-center" data-priority="1">
                                소속 에이전트
                              </th>
                              <th className="text-center" data-priority="1">
                                정보
                              </th>
                              <th className="text-center" data-priority="1">
                                게임정보
                              </th>
                              <th className="text-center" data-priority="1">
                                거래방식
                              </th>
                              <th
                                className="text-center col-currency"
                                data-priority="1"
                              >
                                화폐
                              </th>
                              <th className="text-center" data-priority="1">
                                총 당첨금
                              </th>
                              <th className="text-center" data-priority="1">
                                당첨한도
                              </th>
                              <th className="text-center" data-priority="1">
                                회수금액
                              </th>
                              <th className="text-center" data-priority="1">
                                처리시간
                              </th>
                            </tr>
                          </thead>
                          {totalLogs && (
                            <PaginatedSortableTable
                              data={filteredLogs}
                              renderRow={renderRow}
                              defaultSortField="reg_dt"
                              defaultSortOrder="desc"
                              sortOptions={sortOptions}
                            />
                          )}
                        </table>
                      </div>
                    </div>
                  </div>
                  {/* <div className="card-inner">
                    <div className="row justify-end">
                      <div className="col-12 col-md-6">
                        <ul
                          className="pagination justify-content-center justify-content-md-start"
                          style={{
                            float: "right",
                          }}
                        >
                          <li className="page-item">
                            <a className="page-link disabled" href="#">
                              <i className="fas fa-angle-double-left" />
                              <font>처음</font>
                            </a>
                          </li>
                          <li className="page-item">
                            <a className="page-link disabled" href="#">
                              <i className="fa fa-angle-left" />
                              <font>이전</font>
                            </a>
                          </li>
                          <li className="page-item">
                            <input
                              className="form-control text-center"
                              type="number"
                            />
                          </li>
                          <li className="page-item">
                            <a className="page-link" href="#">
                              <font>다음</font>
                              <i className="fa fa-angle-right" />
                            </a>
                          </li>
                        </ul>
                      </div>
                      <div className="col-6 col-md-3">
                        <select className="form-select">
                          <option value="10">리스트 - 10</option>
                          <option value="20">리스트 - 20</option>
                          <option value="50">리스트 - 50</option>
                          <option value="100">리스트 - 100</option>
                        </select>
                      </div>
                      <div className="col-6 col-md-3">
                        <select className="form-select">
                          <option value="-1">처리시간 - 내림차순</option>
                          <option value="1">처리시간 - 오름차순</option>
                        </select>
                      </div>
                    </div>
                  </div> */}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
